import validate from "/usr/src/nuxt-app/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/usr/src/nuxt-app/middleware/Auth.global.ts";
import new_45notification_45global from "/usr/src/nuxt-app/middleware/NewNotification.global.ts";
import hydrate_45user_45global from "/usr/src/nuxt-app/middleware/hydrate-user.global.ts";
import manifest_45route_45rule from "/usr/src/nuxt-app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  new_45notification_45global,
  hydrate_45user_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "announcement-validation": () => import("/usr/src/nuxt-app/middleware/announcementValidation.ts"),
  "check-cryptext": () => import("/usr/src/nuxt-app/middleware/checkCryptext.ts"),
  "payment-validation": () => import("/usr/src/nuxt-app/middleware/paymentValidation.ts"),
  "redirect-invalid-filters": () => import("/usr/src/nuxt-app/middleware/redirect-invalid-filters.ts")
}